import React from "react";
import {
  Select,
  Checkbox,
  Table,
  Row,
  Col,
  Button,
  Space,
  Dropdown,
  Modal,
  Image,
  Tooltip,
  Popover,
  Popconfirm,
  message,
  Input,
  Form
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import StudentBusAssignmentStore from "../store/StudentBusAssignmentStore";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import withRouter from "../withRouter";
import VehicleStore from "../store/VehicleStore";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import { Link } from "react-router-dom";
import {
  CarOutlined,
  CloseOutlined,
  EditOutlined,
  EyeOutlined,
  FileExcelOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import L from "leaflet";
import Excel from "../assets/images/NewDesign/Excel.svg";
import {
  GoogleMap,
  DirectionsRenderer,
  Marker,
  InfoWindow,
  Polygon,
} from "@react-google-maps/api";

const { Option } = Select;

let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 24) {
      val.width = 250;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 150;
    } else if (val.title?.length > 8) {
      val.width = 125;
    } else {
      val.width = 110;
    }
  });

  return arr;
};

class StudentBusAssignmentList extends React.Component {
  formRef = React.createRef();
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.StudentBusAssignmentStore = new StudentBusAssignmentStore();
    this.vehicleStore = new VehicleStore();
    this.mapRef = React.createRef();


    this.ExportOption = [
      {
        label: (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            {" "}
            <Image
              style={{ height: "18px", width: "18px", borderRadius: "0px" }}
              src={Excel}
            ></Image>
            {context.translate("_ROUTE_MAP_EXCEL_")}
          </div>
        ),
        key: "routeMapexcel",
      },
      {
        label: (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            {" "}
            <Image
              style={{ height: "18px", width: "18px", borderRadius: "0px" }}
              src={Excel}
            ></Image>
            {context.translate("_STANDARD_DATA_EXCEL_")}
          </div>
        ),
        key: "standardDataExcel",
      },
    ];

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      saveModalVisible: false,
      saveMode: "save",
      saveAssignmentName: "",
      selectedVehicles: [],
      selectedgeofenceData: [],
      selectAllVehicles: false,
      selectAllDrivers: false,
      showMonthPopup: false,
      selectAllGeofenceData: false,
      data: "",
      companyId: "",
      Notcompany: false,
      Notasset: false,
      vehicle: false,
      expandedRowKeys: [],
      loadedSummaryData: {},
      selectAllStatus: false,
      status: [],
      innerGridData: [],
      filterNotSelected: false,
      pythonReportMessage: false,
      reportmessage: "",
      toDateNotSelected: false,
      fromDateNotSelected: false,
      garage: "garage",
      viewMap: false,
      studentMapPoints: [],
      plotStudentData: [],
      activeMarker: null,
      selectedpassengerIds: [],
      selectedpassengerIdsByVehicle: {},
      studentSearch: "",
      unassignedOnly: false,
      summary_id: "",
      dateselectedid: "",
      routeDeviationAlert: false,
      routeDeviationOffset: "",
      routeDeviationPopup: false,
      geofencePath: [],
      studentMapData: {},
      deleteRoutePopup: false,
      selectedColumns: widthAdderFunc([
        {
          title: context.translate("_FLEET_DASHBORD_RULETRIGGER_VEHICLE_"),
          dataIndex: "vehicleNo",
          key: "vehicleNo",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("ARABIC_VEHICLE_NO_"),
          dataIndex: "vehicleNoArabic",
          key: "vehicleNoArabic",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_GEOFENCE_"),
          dataIndex: "geofenceName",
          key: "geofenceName",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_SERATER_"),
          dataIndex: "capacity",
          key: "capacity",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_FLEET_CREATEROUTE_ROUTEADD_TOTALTIME_"),
          dataIndex: "totalTripTime",
          key: "totalTripTime",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_SCHOOL_1ST_STUDENT_TIME_"),
          dataIndex: "schoolToFirstStudentTime",
          key: "schoolToFirstStudentTime",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_VEHICLE_1ST_STUDENT_TIME_"),
          dataIndex: "vehicleToFirstStudentTime",
          key: "vehicleToFirstStudentTime",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate(
            "_FLEET_CREATEROUTE_ROUTEADD_TOTALDISTANCE_",
          ),
          dataIndex: "totalTripDistance",
          key: "totalTripDistance",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_SCHOOL_1ST_STUDENT_KM_"),
          dataIndex: "schoolToFirstStudentDistanceKm",
          key: "schoolToFirstStudentDistanceKm",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_VEHICLE_1ST_STUDENT_KM_"),
          dataIndex: "vehicleToFirstStudentDistanceKm",
          key: "vehicleToFirstStudentDistanceKm",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_ASSIGNED_COUNT_"),
          dataIndex: "assignedCount",
          key: "assignedCount",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_ACTION_"),
          dataIndex: "Action",
          // fixed: "right",
          // width: 7,
          ellipsis: true,
          render: (_, record) => {
            return (
              <>
                <Space>
                  <Popconfirm
                    placement="topLeft"
                    title="Assign Vehicle"
                    description="Are you sure you want to assign students to this vehicle?"
                    cancelText="No"
                    okText="Yes"
                    icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                    onConfirm={() => this.updateAssignVehicle(record)}
                  >
                    <CarOutlined
                      style={{
                        paddingLeft: "10px",
                        fontSize: "18px",
                        color: "#1890ff",
                        cursor: "pointer",
                      }}
                    />
                  </Popconfirm>

                  {/* Export Excel for this vehicle only */}
                  <Tooltip title="Export Excel">
                    <FileExcelOutlined
                      style={{
                        fontSize: "18px",
                        color: "#52c41a",
                        cursor: "pointer",
                      }}
                      onClick={async (e) => {
                        e.stopPropagation();
                        await this.StudentBusAssignmentStore.exportStudentVehicleExcel(
                          record,
                        );
                      }}
                    />
                  </Tooltip>
                </Space>
              </>
            );
          },
        },

        {
          title: context.translate("_FLEET_SERVICE_POILIST_VIEWMAP_"),
          width: 100,
          key: "view",
          ellipsis: { showTitle: true },
          render: (value, obj) => {
            console.log(obj.routeDeviationOffset, "obj.routeDeviationOffset")
            return (
              <>
                <Link
                  onClick={async (e) => {
                    await this.showStudentMap(obj);
                    this.setState({
                      studentMapData: obj,
                      routeDeviationAlert: obj.routeDeviation == 1,
                      routeDeviationOffset: obj.routeDeviationOffset || ""
                    })
                    // this.formRef.current.setFieldsValue({ offset: obj.routeDeviationOffset })

                  }}
                >
                  {" "}
                  <img
                    src={require("../assets/images/mapIcon/gps_icon.png")}
                    width={25}
                    height={25}
                  />
                </Link>


              </>
            );
          },
        },
      ]),
    };

    this.menuProps = {
      items: this.ExportOption,
      onClick: async (val) => {
        let result = [];
        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          var getData = {
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            garage: this.state.fromVehicleLocation ? "" : this.state.garage,
            fromVehicleLocation: this.state.fromVehicleLocation,
            unassignedOnly: this.state.unassignedOnly,
            interval: this.state.interval,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
            colList: result.toString(),
            id: this.state.dateselectedid,
          };

          if (val.key == "routeMapexcel") {
            await this.StudentBusAssignmentStore.routeMapexcel(getData);
            const isSuccess =
              this.StudentBusAssignmentStore?.pythonReportMessage === true;
            const isError =
              this.StudentBusAssignmentStore?.pythonReportErrorMessage;

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }
          } else if (val.key == "standardDataExcel") {
            await this.StudentBusAssignmentStore.standardDataExcel(getData);
            const isSuccess =
              this.StudentBusAssignmentStore?.pythonReportMessage === true;
            const isError =
              this.StudentBusAssignmentStore?.pythonReportErrorMessage;

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }
          }
        }
      },
    };

    this.newColumns = [...this.state.selectedColumns];
  }

  async componentDidMount() {
    this.setState({ pageSize: 50 });

    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }
    await this.setState({ column: this.state.selectedColumns });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.state.viewMap !== prevState.viewMap) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      });
    }
  }

  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    await this.setState({ companyId: comp?.value });
    await this.setState({
      selectedVehicles: [],
      selectAllVehicles: false,
      selectedgeofenceData: [],
      selectAllGeofenceData: false,
    });

    await this.vehicleStore.getVehiclesCompanyId(comp?.value);
    console.log(comp?.value, "datedropfilter");
    await this.StudentBusAssignmentStore.datedropfilter(comp?.value);
    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.showData();
  }

  updateAssignVehicle = async (record) => {
    try {
      const selectedPassengerIds =
        this.state.selectedpassengerIdsByVehicle?.[record.vehicleId] ?? [];

      const passengerData = {
        vehicleId: record.vehicleId,
        passengerIds: selectedPassengerIds,
      };

      const response =
        await this.StudentBusAssignmentStore.updateAssignVehicle(passengerData);

      if (response) {
        message.success("Vehicle assigned successfully");
      } else {
        message.error("Unable to assign vehicle");
      }
    } catch (error) {
      message.error("Something went wrong");
    }
  };

  getSavedAssignmentPayload = () => {
    return {
      name: this.state.saveAssignmentName?.trim(),
      companyId: this.state.companyId,
      selectedVehicles: this.state.selectedVehicles,
      selectAllVehicles: this.state.selectAllVehicles,
      garage: this.state.garage,
      fromVehicleLocation: this.state.fromVehicleLocation,
      unassignedOnly: this.state.unassignedOnly,
      savedAt: new Date().toISOString(),
    };
  };

  openSaveModal = (saveMode = "save") => {
    this.setState({
      saveModalVisible: true,
      saveMode,
      saveAssignmentName: "",
    });
  };

  closeSaveModal = () => {
    this.setState({
      saveModalVisible: false,
      saveAssignmentName: "",
      saveMode: "save",
    });
  };

  saveConfig = async () => {
    const { saveAssignmentName, companyId } = this.state;
    console.log(saveAssignmentName, "kkkkkkkkkkkkkkk");
    const postData = {
      assignment_name: saveAssignmentName,
      issave: true,
      summary_id: this.StudentBusAssignmentStore?.summary_id,
      companyId: companyId,
    };
    console.log("?????????/", postData);
    try {
      const result =
        await this.StudentBusAssignmentStore.savepostname(postData);

      // only handle result here, no API logic
      message.success("Assignment saved!");
      await this.StudentBusAssignmentStore.datedropfilter(this.state.companyId);
      this.closeSaveModal();
    } catch (error) {
      message.error("Error saving assignment.");
    }

    // this.closeSaveModal();

    // if (shouldApply) {
    //   await this.showData();
    // }
  };

  saveAssignmentConfig = async () => {
    const { saveAssignmentName, companyId } = this.state;
    console.log(saveAssignmentName, "RRR");
    const postData = {
      assignment_name: saveAssignmentName,
      issaveAssign: true,
      summary_id: this.StudentBusAssignmentStore?.summary_id,
      companyId: companyId,
    };
    console.log("save and asiii", postData);
    try {
      const result =
        await this.StudentBusAssignmentStore.savepostname(postData);

      // only handle result here, no API logic
      message.success("Assignment saved!");
      this.closeSaveModal();
    } catch (error) {
      message.error("Error saving assignment.");
    }

    // this.closeSaveModal();

    // if (shouldApply) {
    //   await this.showData();
    // }
  };

  showData = async () => {
    this.setState({ expandedRowKeys: [] });

    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
      return;
    } else {
      this.setState({ Notcompany: false });
    }

    if (this.state.unassignedOnly && this.state.selectedVehicles.length === 0) {
      this.setState({ Notasset: true });
      return;
    } else {
      this.setState({ Notasset: false });
    }

    const resp = await this.StudentBusAssignmentStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      vehicleId: this.state.selectedVehicles,
      garage: this.state.fromVehicleLocation ? "" : this.state.garage,
      fromVehicleLocation: this.state.fromVehicleLocation,
      unassignedOnly: this.state.unassignedOnly,
      pageNo: this.state.currentPage,
      id: this.state.dateselectedid,
    });
    // console.log(resp, "llllllllllllllllll");
    // ✅ use response directly OR read store after await settles
    const data =
      resp?.data || this.StudentBusAssignmentStore.studentAssignmentStore || [];
    // console.log("summary_id set");
    // const summary_id = this.StudentBusAssignmentStore.summary_id;
    // console.log("summary_id", summary_id);
    // console.log("hhhhhhh", data);
    // await this.setState({ summary_id: resp.summary_id });
    // await this.StudentBusAssignmentStore.datedropfilter(this.state.companyId);

    // console.log("data after load:", data); // 👈 check this first

    const selectedpassengerIdsByVehicle = {};

    data.forEach((vehicle) => {
      selectedpassengerIdsByVehicle[vehicle.vehicleId] = (
        vehicle.studentList || []
      )
        .map((s) => s.passengerId)
        .filter((id) => id != null);
    });

    // console.log("selectedpassengerIdsByVehicle:", selectedpassengerIdsByVehicle); // 👈 check this

    this.setState({
      selectedpassengerIdsByVehicle,
      loadData: 1,
    });
  };

  handleAllSelectVehicles = async (e) => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId?.map(
        (val) => {
          return val.vehicleId;
        },
      );
      await this.setState({ selectedVehicles: allVehicles });
    } else {
      await this.setState({ selectedVehicles: [] });
    }
  };

  onExpand = async (expanded, record) => {
    // console.log(record)
    this.setState({
      expandedRowKeys: expanded ? [record.vehicleId] : [],
    });
  };

  getExpandedColumns = () => {
    const allColumns = [
      {
        title: this.context.translate("_STUDENT_NAME_"),
        dataIndex: "studentName",
        key: "studentName",
        width: 30,
        // width: "10%",
      },
      {
        title: this.context.translate(
          "_FLEET_DASHBORD_HISTORY_TOOLTIP_LOCATION_",
        ),
        dataIndex: "pickUpPoint",
        key: "pickUpPoint",
        width: 200,
        // width: "10%",
      },
      {
        title: this.context.translate(
          "_FLEET_DASHBORD_HISTORY_TOOLTIP_MOBILE_",
        ),
        dataIndex: "mobileNo",
        key: "mobileNo",
        width: 20,
        // width: "10%",
      },
      {
        title: this.context.translate("_FLEET_REPORTS_STOPREPORT_ARRIVALTIME_"),
        dataIndex: "legTime",
        key: "legTime",
        width: 15,
        // width: "10%",
      },
      {
        title: this.context.translate("_DISTANCE_"),
        dataIndex: "legDistanceKm",
        key: "legDistanceKm",
        width: 15,
        // width: "10%",
      },
    ];

    return allColumns;
  };

  expandedRowRender = (record) => {
    const columns = this.getExpandedColumns();

    const studentList = record.studentList || [];

    const searchText = this.state.studentSearch || "";

    const filteredStudents = studentList.filter((item) =>
      item.studentName?.toLowerCase().includes(searchText.toLowerCase()),
    );

    const selectedIds =
      this.state.selectedpassengerIdsByVehicle?.[record.vehicleId];

    const finalSelectedIds =
      selectedIds ??
      studentList.map((x) => x.passengerId).filter((id) => id != null);

    const rowSelection = {
      selectedRowKeys: finalSelectedIds,

      onChange: (keys) => {
        const cleanKeys = keys.filter((id) => id != null);

        this.setState((prev) => ({
          selectedpassengerIdsByVehicle: {
            ...prev.selectedpassengerIdsByVehicle,
            [record.vehicleId]: cleanKeys,
          },
        }));
      },

      preserveSelectedRowKeys: true,
      columnWidth: 10,
    };

    return (
      <div className="innerGridTbl">
        <input
          placeholder="Search Student"
          value={this.state.studentSearch}
          onChange={(e) => this.setState({ studentSearch: e.target.value })}
          style={{
            width: 180,
            marginBottom: 8,
            padding: 5,
            border: "1px solid #d9d9d9",
            borderRadius: 4,
          }}
        />

        <Table
          className="studentExpandedTable"
          bordered
          size="small"
          pagination={false}
          columns={columns}
          dataSource={filteredStudents}
          rowKey={(row) => row.passengerId}
          rowSelection={rowSelection}
        />
      </div>
    );
  };

  refreshList = async () => {
    await this.setState({ loading: false, pageNo: 1, currentPage: 1 });
    await this.showData();
  };

  // ── Map helpers (student lat/long + route) ──────────────────────────────
  showStudentMap = (record) => {
    const points = (record.studentList || [])
      .filter((s) => s.pickupLat && s.pickupLong)
      .map((s) => ({
        lat: parseFloat(s.pickupLat),
        lng: parseFloat(s.pickupLong),
        name: s.studentName || "Student",
        pickUpPoint: s.pickUpPoint || "",
      }));
    this.pendingMapPoints = points;

    this.setState({ viewMap: true }, () => {
      // setState callback — runs after render, map is visible
      setTimeout(() => this.drawStudentMarkers(), 400);
    });
  };

  // showStudentMap = (record) => {
  //   const used = {};

  //   const points = (record.studentList || []).map((s) => {
  //     let lat = parseFloat(s.pickupLat);
  //     let lng = parseFloat(s.pickupLong);

  //     const key = `${lat},${lng}`;
  //     used[key] = (used[key] || 0) + 1;

  //     const count = used[key] - 1;

  //     // Offset duplicates slightly
  //     lat = lat + count * 0.00015;
  //     lng = lng + count * 0.00015;

  //     return {
  //       lat,
  //       lng,
  //       name: s.studentName || "Student",
  //       pickUpPoint: s.pickUpPoint || "",
  //     };
  //   });

  //   this.pendingMapPoints = points;

  //   this.setState({ viewMap: true }, () => {
  //     setTimeout(() => this.drawStudentMarkers(), 400);
  //   });
  // };

  drawStudentMarkers = () => {
    const map = this.mapRef.current;
    if (!map) return;

    const points = this.pendingMapPoints || [];
    if (points.length === 0) return;

    // Clear old markers only
    map.eachLayer((layer) => {
      if (layer instanceof L.Marker || layer instanceof L.CircleMarker) {
        map.removeLayer(layer);
      }
    });

    // Group consecutive same coordinates
    const groups = [];
    let current = null;

    points.forEach((p, index) => {
      const key = `${p.lat},${p.lng}`;
      const seq = index + 1;

      if (!current || current.key !== key) {
        current = {
          key,
          lat: p.lat,
          lng: p.lng,
          startSeq: seq,
          endSeq: seq,
          pickUpPoint: p.pickUpPoint || "",
          students: [{ ...p, seq }],
        };

        groups.push(current);
      } else {
        current.endSeq = seq;
        current.students.push({ ...p, seq });
        current.endSeq = seq;
      }
    });

    // Plot markers only
    groups.forEach((g, index) => {
      const isFirst = index === 0;
      const isLast = index === groups.length - 1;

      let color = "#1890ff"; // middle

      if (isFirst) color = "#52c41a"; // green
      if (isLast) color = "#f5222d"; // red

      const label =
        g.startSeq === g.endSeq ? `${g.startSeq}` : `${g.startSeq}-${g.endSeq}`;

      const icon = L.divIcon({
        className: "",
        html: `
          <div style="
            width:38px;
            height:38px;
            border-radius:50%;
            background:${color};
            border:2px solid #fff;
            display:flex;
            align-items:center;
            justify-content:center;
            color:#fff;
            font-size:11px;
            font-weight:bold;
            box-shadow:0 2px 6px rgba(0,0,0,.35);
          ">
            ${label}
          </div>
        `,
        iconSize: [38, 38],
        iconAnchor: [19, 19],
      });

      const popupHtml = `
        <div style="min-width:180px">
          <b>Stop ${label}</b><br/>
          <b>${g.pickUpPoint}</b><br/><br/>
          ${g.students.map((s) => `${s.seq}. ${s.name}`).join("<br/>")}
        </div>
      `;

      L.marker([g.lat, g.lng], { icon }).addTo(map).bindPopup(popupHtml);
    });

    // Fit markers in view
    const bounds = groups.map((g) => [g.lat, g.lng]);

    if (bounds.length > 1) {
      map.fitBounds(bounds, {
        padding: [40, 40],
        maxZoom: 15,
      });
    } else {
      map.setView(bounds[0], 15);
    }
  };

  closeStudentMap = () => {
    const map = this.mapRef.current;
    if (map) {
      map.eachLayer((layer) => {
        if (layer instanceof L.Marker || layer instanceof L.Polyline) {
          map.removeLayer(layer);
        }
      });
    }
    this.pendingMapPoints = [];

    this.setState({ viewMap: false, directions: null, activeMarker: null, routeDeviationAlert: false, geofencePath: [] });
  };
  // ────────────────────────────────────────────────────────────────────────

  getRoute = async () => {
    const { pendingMapPoints } = this;

    if (!window.google || !window.google.maps) return;
    if (!pendingMapPoints || pendingMapPoints.length < 2) return;

    const directionsService = new window.google.maps.DirectionsService();

    const chunks = this.chunkPoints(pendingMapPoints);

    const routes = [];

    for (let i = 0; i < chunks.length; i++) {
      const segment = chunks[i];

      const origin = segment[0];
      const destination = segment[segment.length - 1];

      const waypoints = segment.slice(1, -1).map((p) => ({
        location: { lat: p.lat, lng: p.lng },
        stopover: true,
      }));

      const request = {
        origin,
        destination,
        waypoints,
        travelMode: window.google.maps.TravelMode.DRIVING,
      };

      try {
        const result = await new Promise((resolve, reject) => {
          directionsService.route(request, (res, status) => {
            if (status === "OK") resolve(res);
            else reject(status);
          });
        });

        routes.push(result);
      } catch (err) {
        console.error("Segment failed:", err);
      }
    }

    this.setState({
      directionsList: routes,
      center: pendingMapPoints[0],
    });
  };

  chunkPoints(points) {
    const MAX_POINTS = 25;
    const chunks = [];

    for (let i = 0; i < points.length; i += MAX_POINTS - 1) {
      chunks.push(points.slice(i, i + MAX_POINTS));
    }

    return chunks;
  }

  buildRouteMarkers = () => {
    const { directionsList } = this.state;
    const original = this.pendingMapPoints || [];

    if (!directionsList) return [];

    const markers = [];

    let indexCounter = 0;

    directionsList.forEach((dir) => {
      const legs = dir.routes[0].legs;

      legs.forEach((leg) => {
        // first point
        if (markers.length === 0) {
          markers.push({
            lat: leg.start_location.lat(),
            lng: leg.start_location.lng(),
            name: original[indexCounter]?.name,
            address: original[indexCounter]?.address,
          });
          indexCounter++;
        }

        // each stop
        markers.push({
          lat: leg.end_location.lat(),
          lng: leg.end_location.lng(),
          name: original[indexCounter]?.name,
          address: original[indexCounter]?.pickUpPoint,
        });

        indexCounter++;
      });
    });

    return markers;
  };

  buildGroupedMarkers = () => {
    const markers = this.buildRouteMarkers();

    const grouped = {};

    markers.forEach((point, index) => {
      const key = `${point.lat.toFixed(5)}-${point.lng.toFixed(5)}`;

      if (!grouped[key]) {
        grouped[key] = {
          lat: point.lat,
          lng: point.lng,
          indexes: [],
          names: [],
          addresses: [],
          isSchool: false,
        };
      }

      grouped[key].indexes.push(index + 1);
      grouped[key].names.push(point.name);
      grouped[key].addresses.push(point.address);
      if (point.name?.toLowerCase().includes("school")) {
        grouped[key].isSchool = true;
      }
    });

    return Object.values(grouped);
  };

  handleDateFields = async (value) => {
    console.log("Selected Assignment ID:", value);

    this.setState({
      dateselectedid: value,
    });
    // await this.showData();
  };

  getRoutePolylinePoints = () => {
    const { directionsList } = this.state;
    if (!directionsList?.length) return [];

    const points = [];

    directionsList.forEach((dir) => {
      const legs = dir.routes[0].legs;
      legs.forEach((leg) => {
        leg.steps.forEach((step) => {
          // decode the polyline of each step
          const path = step.path ||
            window.google.maps.geometry.encoding.decodePath(
              step.polyline.points
            );
          path.forEach((latLng) => {
            points.push({
              lat: latLng.lat(),
              lng: latLng.lng(),
            });
          });
        });
      });
    });

    return points;
  };

  createGeofenceFromRoute = (routePoints, offsetMeters) => {
    if (!routePoints?.length || !offsetMeters) return [];

    const R = 6371000; // Earth radius in meters

    // Generate offset points on both sides of the route
    const leftSide = [];
    const rightSide = [];

    for (let i = 0; i < routePoints.length; i++) {
      const curr = routePoints[i];

      // Use prev→next to get direction, fallback to neighbors
      const prev = routePoints[i - 1] || curr;
      const next = routePoints[i + 1] || curr;

      // Bearing from prev to next
      const bearing = this.getBearing(prev, next);

      // Perpendicular bearings
      const leftBearing = (bearing - 90 + 360) % 360;
      const rightBearing = (bearing + 90) % 360;

      leftSide.push(
        this.offsetPoint(curr, offsetMeters, leftBearing)
      );
      rightSide.push(
        this.offsetPoint(curr, offsetMeters, rightBearing)
      );
    }

    // Close the polygon: left side forward + right side backward
    return [
      ...leftSide,
      ...rightSide.reverse(),
      leftSide[0], // close
    ];
  };

  // ── Helpers ──────────────────────────────────────────────────

  getBearing = (from, to) => {
    const lat1 = (from.lat * Math.PI) / 180;
    const lat2 = (to.lat * Math.PI) / 180;
    const dLng = ((to.lng - from.lng) * Math.PI) / 180;

    const y = Math.sin(dLng) * Math.cos(lat2);
    const x =
      Math.cos(lat1) * Math.sin(lat2) -
      Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLng);

    return ((Math.atan2(y, x) * 180) / Math.PI + 360) % 360;
  };

  offsetPoint = (point, distanceMeters, bearingDeg) => {
    const R = 6371000;
    const bearing = (bearingDeg * Math.PI) / 180;
    const lat1 = (point.lat * Math.PI) / 180;
    const lng1 = (point.lng * Math.PI) / 180;
    const d = distanceMeters / R;

    const lat2 = Math.asin(
      Math.sin(lat1) * Math.cos(d) +
      Math.cos(lat1) * Math.sin(d) * Math.cos(bearing)
    );

    const lng2 =
      lng1 +
      Math.atan2(
        Math.sin(bearing) * Math.sin(d) * Math.cos(lat1),
        Math.cos(d) - Math.sin(lat1) * Math.sin(lat2)
      );

    return {
      lat: (lat2 * 180) / Math.PI,
      lng: (lng2 * 180) / Math.PI,
    };
  };

  zoomToGeofence = (geofencePath) => {
    if (!this.mapRef || !geofencePath?.length) return;

    const bounds = new window.google.maps.LatLngBounds();

    geofencePath.forEach((point) => {
      bounds.extend(new window.google.maps.LatLng(point.lat, point.lng));
    });

    this.mapRef.fitBounds(bounds, {
      top: 50,
      right: 50,
      bottom: 50,
      left: 50,
    });
  };

  saveGeofenceData = async (geofence) => {
    let coockieData =
      JSON.parse(base64_decode(Cookies.get("data")))

    // console.log(coockieData, "coockieData")
    const userMobile = coockieData.mobileNo;
    const emailId = coockieData.emailId;
    // console.log(userMobile, emailId)
    const rowData = this.state.studentMapData

    const result = geofence
      .map(p => `${p.lat},${p.lng},0`)
      .join(",");

    const ruleData = {
      "companyId": this.state.companyId,
      ruleName: `${rowData.vehicleNo} outside geofence`,
      "minimumInterval": "10",
      "notificationEmail": userMobile,
      "notifyMobile": emailId,
      "active": "Yes",
      "triggerAction": 1,
      "emailSubCheckBx": [
        1,
        2,
        3,
        4
      ],
      "vehicleNo": [
        rowData.vehicleId
      ],
      "Rule15geofencename": [
        "2"
      ],
      "Rule15EventName": "Outside",
      "RuleSelector": {
        "RuleSelectorId": 15,
        "Ruleparams": "{\"Rule15geofencename\":[\"2\"],\"Rule15EventName\":\"Outside\"}",
        "enable": true
      },
      "ruleId": 0,
      "vehicle": [
        rowData.vehicleId
      ],
      "pushnotification": 1,
      "webpushnotification": 1,
      "userId": this.props.getUserData().userId
    }

    const geofenceData = {
      points: result,
      companyId: this.state.companyId,
      type: 3,
      isactive: 1,
      name: `${rowData.vehicleNo}_route`,
    }

    // console.log(result);
    const data = {
      companyId: this.state.companyId,
      vehicleId: rowData.vehicleId,
      routeDeviation: this.state.routeDeviationAlert ? 1 : 0,
      ruleData: ruleData,
      geofenceData: geofenceData,
      routeDeviationOffset: this.state.routeDeviationOffset
    }

    const response = await this.StudentBusAssignmentStore.saveMapPoints(data)
    console.log(response.message, "response.message")
    if (response?.success === "S") {
      message.success(response.message);
    } else {
      message.error(response.message);
    }
  }
  deleteRouteDeviation = async () => {
    console.log("sdfghnmnbvcx", this.state.studentMapData)
    const studentData = this.state.studentMapData
    const response = await this.StudentBusAssignmentStore.delteMapPoints(studentData)
    if (response?.success === "S") {
      message.success(response.message);
    } else {
      message.error(response.message);
    }
  }
  render() {
    const groupedMarkers = this.buildGroupedMarkers();

    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  onChange={this.handleChange}
                  className="searchInput"
                  allowClear={true}
                  style={{ width: 150 }}
                  status={this.state.Notcompany ? "error" : false}
                />
                {this.props.getUserData().isadmin === 1 && (
                  <>
                    <DeviceGroupsForVehicles
                      vehicleStore={this.vehicleStore}
                      setLoadDta={() => this.setState({ loadData: 1 })}
                      resetVehicles={() =>
                        this.setState({
                          selectedVehicles: [],
                          selectAllVehicles: false,
                        })
                      }
                    />
                  </>
                )}

                <>
                  <Checkbox
                    checked={this.state.unassignedOnly}
                    onChange={(e) => {
                      this.setState(
                        {
                          unassignedOnly: e.target.checked,
                          selectedVehicles: [],
                          selectAllVehicles: false,
                        },
                        async () => {
                          await this.vehicleStore.getVehiclesCompanyId(
                            this.state.companyId,
                            e.target.checked,
                          );
                          this.setState({ loadData: 1 });
                        },
                      );
                    }}
                  />
                  {this.context.translate("_UNASSIGNED_ONLY_")}

                  <Checkbox
                    checked={this.state.selectAllVehicles}
                    onChange={async (e) => {
                      await this.setState({
                        selectAllVehicles: e.target.checked,
                      });
                      if (this.state.selectAllVehicles) {
                        await this.setState({
                          Notasset: false,
                        });
                      }
                      await this.handleAllSelectVehicles();
                    }}
                  />

                  {this.context.translate("_ALL_")}

                  <Select
                    maxTagCount="responsive"
                    className="searchInput"
                    value={this.state.selectedVehicles}
                    onChange={(val) => {
                      this.setState({ selectedVehicles: val });
                      if (
                        this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                        val.length
                      ) {
                        this.setState({ selectAllVehicles: false });
                      } else {
                        this.setState({ selectAllVehicles: true });
                      }

                      if (val?.length > 1) {
                        this.setState({ showAlertPopup: true });
                      }
                    }}
                    style={{ width: 180 }}
                    showSearch
                    status={this.state.Notasset ? "error" : false}
                    mode="multiple"
                    placeholder={this.context.translate(
                      "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_",
                    )}
                    filterOption={(inputValue, option) => {
                      if (option.children) {
                        return (
                          option.children
                            .toLowerCase()
                            .indexOf(inputValue.toLowerCase()) >= 0
                        );
                      }
                    }}
                  >
                    {this.vehicleStore?.getVehiclesUsingCompanyId?.map(
                      (val) => {
                        return (
                          <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                        );
                      },
                    )}
                  </Select>
                </>
                {
                  <Select
                    defaultValue={this.context.translate("_GARAGE_")}
                    style={{ width: 100 }}
                    onSelect={(garage) => this.setState({ garage: garage })}
                    placeholder={this.context.translate("_START_LOCATION_")}
                    className="searchInput"
                    disabled={this.state.fromVehicleLocation}
                  >
                    <Select.Option value="garage">
                      {this.context.translate("_GARAGE_")}
                    </Select.Option>
                  </Select>
                }

                <Checkbox
                  checked={this.state.fromVehicleLocation}
                  onChange={async (e) => {
                    await this.setState({
                      fromVehicleLocation: e.target.checked,
                    });
                  }}
                />
                {this.context.translate("_FROM_VEHICLE_LOCATION_")}

                <Select
                  showSearch
                  allowClear
                  placeholder="Select Date"
                  style={{ width: 150 }}
                  className="searchInput"
                  onChange={(value) => this.handleDateFields(value)}
                  filterOption={(input, option) =>
                    String(option?.children)
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {this.StudentBusAssignmentStore?.datetimedrop.map((val) => {
                    return (
                      <Option key={val.id} value={val.id}>
                        {val.assignmentLabel}
                      </Option>
                    );
                  })}
                </Select>

                <Button
                  type="primary"
                  onClick={() => {
                    this.showData();
                  }}
                >
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={4}
            >
              <Space>
                <Button
                  onClick={() => this.openSaveModal("save")}
                  disabled={
                    this.StudentBusAssignmentStore?.studentAssignmentStore
                      ?.length > 0
                      ? false
                      : true
                  }
                >
                  Save
                </Button>

                {/* <Button
                  type="primary"
                  onClick={() => this.openSaveModal("saveAndApply")}
                >
                  Save & Apply
                </Button> */}
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>

                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.StudentBusAssignmentStore?.studentAssignmentStore
                      ?.length > 0
                      ? false
                      : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.menuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Col>
          </Row>
          {/* SUMMARY CARDS START */}
          <Row gutter={16} style={{ marginBottom: 15, marginTop: 15 }}>
            <Col span={6}>
              <div className="summaryCard">
                <h4>Total Students</h4>
                <h2>
                  {this.StudentBusAssignmentStore?.summary?.totalStudents || 0}
                </h2>
              </div>
            </Col>

            <Col span={6}>
              <div className="summaryCard">
                <h4>Assigned Students</h4>
                <h2>
                  {this.StudentBusAssignmentStore?.summary?.assignedStudents ||
                    0}
                </h2>
              </div>
            </Col>

            <Col span={6}>
              <div className="summaryCard">
                <h4>Buses Used</h4>
                <h2>
                  {this.StudentBusAssignmentStore?.summary?.busesUsed || 0}
                </h2>
              </div>
            </Col>

            <Col span={6}>
              <div className="summaryCard">
                <h4>Available Buses</h4>
                <h2>
                  {this.StudentBusAssignmentStore?.summary?.busesAvailable || 0}
                </h2>
              </div>
            </Col>
          </Row>
          {/* SUMMARY CARDS END */}
          <ListTable
            rowKey="vehicleId"
            key={this.state.selectedColumns.length}
            expandable={{
              expandedRowRender: this.expandedRowRender,
              onExpand: this.onExpand,
              expandedRowKeys: this.state.expandedRowKeys,
            }}
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            columns={this.state.column}
            total={this.StudentBusAssignmentStore?.total}
            dataSource={this.StudentBusAssignmentStore?.studentAssignmentStore}
            loading={this.StudentBusAssignmentStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        <Modal
          title="Save Assignment"
          open={this.state.saveModalVisible}
          onCancel={this.closeSaveModal}
          footer={[
            <Button key="save" onClick={() => this.saveConfig()}>
              Save
            </Button>,
            <Popconfirm
              title="Are you sure?"
              description="Do you want to continue?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => this.saveAssignmentConfig()}
            >
              <Button key="saveAndApply" type="primary">
                Save & Apply
              </Button>
            </Popconfirm>,
          ]}
        >
          <Input
            placeholder="Enter name"
            value={this.state.saveAssignmentName}
            onChange={(e) =>
              this.setState({ saveAssignmentName: e.target.value })
            }
            onPressEnter={() =>
              this.saveAssignmentConfig(this.state.saveMode === "saveAndApply")
            }
          />
        </Modal>

        <Modal
          width={350}
          className="alert-model"
          title={
            <div>
              {" "}
              <i
                style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                class="bi bi-exclamation-triangle"
              ></i>{" "}
              {this.context.translate("_FLEET_ALERT_")}
            </div>
          }
          open={this.state.showMonthPopup}
          onOk={() => this.setState({ showMonthPopup: false })}
          onCancel={() => this.setState({ showMonthPopup: false })}
          footer={false}
        >
          {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
        </Modal>
        {/* ── Student Location & Route Map Modal ───────────────────────── */}

        <Modal
          className="multiTracking-popup"
          maskClosable={false}
          title={
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span>
                {this.context.translate("_FLEET_SERVICE_POILIST_VIEWMAP_")}
              </span>
              <CloseOutlined onClick={() => this.closeStudentMap()} />
            </div>
          }
          open={this.state.viewMap}
          centered
          bodyStyle={{ height: "75vh" }}
          width={1200}
          footer={false}
        >
          <div style={{ position: "relative", height: "75vh" }}>
            <div
              style={{
                position: "absolute",
                top: "52px",
                left: "10px",
                zIndex: 999,
                background: "#fff",
                padding: "8px 12px",
                borderRadius: "6px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.2)"
              }}
            >
              <Checkbox
                checked={this.state.routeDeviationAlert}
                onChange={(e) => {
                  const checked = e.target.checked;

                  if (
                    !checked &&
                    Number(this.state.studentMapData?.routeDeviation) === 1
                  ) {
                    this.setState({
                      deleteRoutePopup: true,
                    });
                    return;
                  }


                  this.setState({
                    routeDeviationAlert: e.target.checked,
                  });
                  if (checked) {
                    this.setState({ routeDeviationPopup: true })
                  }
                }}
              >
                Deviation Alert
              </Checkbox>


              {this.state.routeDeviationAlert && (
                <EditOutlined
                  style={{
                    color: "#1890ff",
                    cursor: "pointer",
                    fontSize: "16px",
                  }}
                  onClick={() => {
                    this.setState({
                      routeDeviationPopup: true,
                    });
                  }}
                />
              )}
            </div>

            {this.state.routeDeviationPopup && (
              <Modal
                open={this.state.routeDeviationPopup}
                title="Route Deviation Alert"
                centered
                footer={null}
                onCancel={() =>
                  this.setState({ routeDeviationPopup: false })
                }
                width={400}
              >
                <Form ref={this.formRef} layout="vertical">
                  <Form.Item
                    // name="offset"
                    label="Offset"
                    rules={[
                      { required: true, message: "Please enter offset" },
                      { pattern: /^\d+$/, message: "Must be a number" },
                    ]}
                  >
                    <Input
                      style={{ width: 350 }}
                      placeholder="e.g. 50 for 50 meters"
                      value={this.state.routeDeviationOffset}
                      onChange={(e) =>
                        this.setState({
                          routeDeviationOffset: e.target.value
                        })
                      }
                    />
                  </Form.Item>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "10px",
                      marginTop: "10px"
                    }}
                  >

                    <Button
                      type="primary"

                      onClick={() => {
                        const offset = Number(this.state.routeDeviationOffset);
                        if (!offset) return;

                        const routePoints = this.getRoutePolylinePoints();

                        if (routePoints.length === 0) {
                          message.warning("Route not loaded yet");
                          return;
                        }

                        const geofence = this.createGeofenceFromRoute(
                          routePoints,
                          offset   // offset in meters e.g. 100 = 100m buffer
                        );

                        console.log(geofence, "geofence")

                        this.setState({
                          geofencePath: geofence,
                          routeDeviationPopup: false,
                        },
                          () => {
                            // ← runs after state is set and polygon is rendered
                            this.zoomToGeofence(geofence);
                          }
                        );

                        this.saveGeofenceData(geofence)
                      }}
                    >
                      Show
                    </Button>
                  </div>
                </Form>
              </Modal>
            )}

            <Modal
              open={this.state.deleteRoutePopup}
              title="Delete Route Deviation"
              onCancel={() =>
                this.setState({
                  deleteRoutePopup: false,
                  routeDeviationAlert: true, // keep checked
                })
              }
              footer={null}
            >
              <p>Are you sure you want to delete this route deviation?</p>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                }}
              >
                <Button
                  onClick={() =>
                    this.setState({
                      deleteRoutePopup: false,
                      routeDeviationAlert: true,
                    })
                  }
                >
                  Cancel
                </Button>

                <Button
                  danger
                  type="primary"
                  onClick={async () => {
                    // Call API here

                    await this.deleteRouteDeviation();

                    this.setState({
                      deleteRoutePopup: false,
                      routeDeviationAlert: false,
                      geofencePath: [],
                    });
                  }}
                >
                  Delete
                </Button>
              </div>
            </Modal>
            <GoogleMap
              key={JSON.stringify(this.pendingMapPoints)}
              mapContainerStyle={{ height: "75vh", width: "100%" }}
              zoom={13}
              center={{ lat: 24.7136, lng: 46.6753 }}
              onLoad={(map) => {
                this.mapRef = map;
                this.getRoute();
              }}
              libraries={["geometry"]}
            >
              {this.state.directionsList?.map((dir, i) => (
                <DirectionsRenderer
                  key={i}
                  directions={dir}
                  options={{ suppressMarkers: true }}
                />
              ))}

              {groupedMarkers.map((point, index) => {
                const labelText = point.indexes.join("-");

                const isFirst = point.indexes.includes(1);
                const isLast = point.isSchool;

                return (
                  <Marker
                    key={index}
                    position={{ lat: point.lat, lng: point.lng }}
                    onClick={() => this.setState({ activeMarker: index })}
                    label={{
                      text: labelText,
                      color: "#fff",
                      fontSize: "9px",
                      fontWeight: "bold",
                    }}
                    icon={{
                      path: window.google.maps.SymbolPath.CIRCLE,
                      scale: 18,
                      fillColor: isFirst
                        ? "#52c41a"
                        : isLast
                          ? "#f5222d"
                          : "#1890ff",
                      fillOpacity: 1,
                      strokeColor: "#fff",
                      strokeWeight: 2,
                    }}
                  >
                    {this.state.activeMarker === index && (
                      <InfoWindow
                        onCloseClick={() =>
                          this.setState({ activeMarker: null })
                        }
                      >
                        <div
                          style={{
                            width: "220px", // ✅ fixed width
                            minHeight: "80px",
                          }}
                        >
                          <strong>Stops:</strong> {labelText}
                          <div style={{ marginTop: "6px" }}>
                            <strong>Students:</strong>
                            {point.names && point.names.length > 0 ? (
                              <ul style={{ paddingLeft: "16px", margin: 0 }}>
                                {point.names.map((name, i) => (
                                  <li key={i}>
                                    <div>{name}</div>
                                    <div
                                      style={{
                                        fontSize: "10px",
                                        color: "#888",
                                      }}
                                    >
                                      {point.addresses[i] || "-"}
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            ) : (
                              <div style={{ color: "#999", marginTop: "4px" }}>
                                No data available
                              </div>
                            )}
                          </div>
                        </div>
                      </InfoWindow>
                    )}
                  </Marker>
                );
              })}

              {
                this.state.geofencePath?.length > 0 && (
                  <Polygon
                    paths={this.state.geofencePath}
                    options={{
                      fillColor: "#ff0000",
                      fillOpacity: 0.2,
                      strokeColor: "#ff0000",
                      strokeOpacity: 0.8,
                      strokeWeight: 2,
                    }}
                  />
                )
              }
            </GoogleMap>
          </div >
        </Modal >
        {/* ──────────────────────────────────────────────────────────────── */}
      </>
    );
  }
}
StudentBusAssignmentList.contextType = StoreContext;
export default observer(withRouter(StudentBusAssignmentList));
